import React from 'react';
import MiniAppEvents from 'src/helpers/miniapp-events';
import './merchant-agreement-link.scss';

export default function MerchantAgreementLink({ className = '' }) {
  const inMiniProgram = MiniAppEvents.isInMiniApp();
  const merchantAgreementURL =
    'https://www.vodacombusiness.co.za/sites/vodacombusinesscoza/files/media/documents/terms-and-conditions/vodacom-merchant-agreement.pdf';
  const merchantAgreementMiniAppURL =
    'https://vodapay.vodacom.co.za/vodapay/terms/vodacom-merchant-agreement';

  return (
    <div
      className={`MerchantAgreementLink has-text-centered merchant-agreement-content ${className}`}
    >
      By continuing, I agree to the Vodacom digital terms and&nbsp;
      {inMiniProgram ? (
        <span
          id="merchant-agreement-link-miniapp"
          automationid="Onboarding_Lets_Get_Started_Span_Link_Merchant_Agreement"
          onClick={() => {
            MiniAppEvents.sendMessage({
              messageType: 'new tab',
              data: merchantAgreementMiniAppURL,
            });
          }}
        >
          merchant agreement.
        </span>
      ) : (
        <a
          id="merchant-agreement-link"
          href={merchantAgreementURL}
          automationid="Onboarding_Lets_Get_Started_Span_Link_Merchant_Agreement"
          target="_blank"
          rel="noreferrer"
        >
          merchant agreement.
        </a>
      )}
    </div>
  );
}
